import React from "react";
import Navbar from "./Navbar";
import {
  CustomFlex,
  CenteredFlex,
  CustomGrid,
  ColoredButton,
} from "./Layout.elements";
import { black, yellow } from "../color";
import heroImage from "../assets/images/hero-image.svg";
import { Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import styled from "@emotion/styled";

const { blackPearl } = black;

const HeroFlex = styled(CenteredFlex)`
  background-color: ${blackPearl};
  padding: 0px 7.5rem;
  @media only screen and (max-width: 768px) {
    padding: 2.5rem 1.5rem;
  }
`;

const ResponsiveGrid = styled(CustomGrid)`
  margin-top: 5rem;
  margin-bottom: 5rem;
  @media only screen and (max-width: 768px) {
    margin-bottom: 0;
    margin-top: 2.5rem;
  }
  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const CenterAlignedBox = styled(CustomFlex)`
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

const GridSection = styled(CustomGrid)`
  margin-left: 70px;
  @media only screen and (max-width: 768px) {
    margin-left: 0;
  }
`;

const ResponsiveImage = styled.img`
  @media only screen and (max-width: 1024px) {
    width: 300px;
    height: 300px;
  }
`;

const AppCoderBtn = styled(ColoredButton)`
  text-transform: none;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const HeroSection = (props) => {
  const btnText = "Try Interplay AppCoder LLM";
  const params = new URLSearchParams(window.location.search);

  const handleRedirect = () => {
    props.setBlackScreen(!props.blackScreen);
    params.set("q", "new");
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <>
      <Navbar />
      <HeroFlex direction="column">
        <CenterAlignedBox direction="column" align="center">
          <h1 className="headline">The Future of Code</h1>
          <p className="subheading">
            Embarking on exciting projects at Iterate.ai, we've been
            experimenting with several LLMs on the latest AI frameworks and
            libraries to improve the technology that powers our projects. Our
            goal was to generate working and updated code for generative AI
            projects that we build alongside our enterprise clients.
          </p>
        </CenterAlignedBox>
        <ResponsiveGrid container rowSpacing={1}>
          <CustomFlex xs={12} sm={6} md={6} direction="column">
            <ResponsiveImage src={heroImage} alt="" />
          </CustomFlex>
          <GridSection xs={12} sm={6} md={6} content="flex-end">
            <Grid style={{ borderTop: `${yellow[900]}`, borderWidth: "5px" }}>
              <h3 className="white-font">THE RESULT</h3>
              <p className="font-size-40 font-w-300 resp-font">
                Interplay-AppCoder LLM, a revolutionary new high performing code
                generation model
              </p>
              <AppCoderBtn
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={handleRedirect}
                style={{
                  textTransform: "none"
                }}
              >
                {btnText}
              </AppCoderBtn>
            </Grid>
          </GridSection>
        </ResponsiveGrid>
      </HeroFlex>
    </>
  );
};

export default HeroSection;
